<template>
  <s-modal
    v-model="showModal"
    class="details-modal"
    ok-only
    :ok-title="$t('actions.close')"
    :title="$t('general.subtitle')"
    @ok="closeModal"
  >
    <s-table
      class="details-modal__table-overflow details-modal__table"
      sticky-header
      :fields="fields"
      :items="terms"
    >
      <template #cell(term)="{ item }">
        <strong>{{ item.term }}</strong>
      </template>
      <template #cell(description)="{ item }">
        {{ item.description }}
      </template>
    </s-table>
  </s-modal>
</template>

<script>
import TermsAndDescription from '@/domain/data/installation/engineering/chromatography/methodsAndDiagnostics/terms-and-description.json';

export default {
  data: () => ({}),
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    fields() {
      return [
        {
          key: 'term',
          label: this.$t('general.term'),
          tdClass: 'details-modal__td-term',
          thClass: 'details-modal__th-term',
        },
        {
          key: 'description',
          label: this.$t('general.description'),
          thClass: 'details-modal__th-description',
          tdClass: 'details-modal__td-description',
        },
      ];
    },
    terms() {
      return TermsAndDescription.map(termAndDescription => ({
        term: termAndDescription.term,
        description: this.$t(termAndDescription.description),
      }));
    },
    showModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style lang="sass">
  .details-modal
    &__th-term,
    &__th-description
      background: var(--color-table-header-bg)!important
    &__th-term,
    &__td-term
      border-right: 2px solid #FFF
      text-align: center!important
    &__td-description,
    &__th-description
      text-align: left!important
    &__table-overflow
      max-height: 30vh
      overflow-x: hidden
      overflow-y: scroll
    &__table
      border: 1px solid var(--color-border-regular)
      box-sizing: border-box
      border-radius: 5px

</style>
